export const MAX_ITEMS = 3

export default {
  MAX_ITEMS,
}



// WEBPACK FOOTER //
// ./src/constants.js